/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Legaroo_Landing_Feature_4Inputs */

const en_service_legaroo_landing_feature_4 = /** @type {(inputs: Service_Legaroo_Landing_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Travel legal info`)
};

const fr_service_legaroo_landing_feature_4 = /** @type {(inputs: Service_Legaroo_Landing_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Info juridique voyage`)
};

/**
* | output |
* | --- |
* | "Travel legal info" |
*
* @param {Service_Legaroo_Landing_Feature_4Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const service_legaroo_landing_feature_4 = /** @type {((inputs?: Service_Legaroo_Landing_Feature_4Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Legaroo_Landing_Feature_4Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_service_legaroo_landing_feature_4(inputs)
	return fr_service_legaroo_landing_feature_4(inputs)
});